var Event = require("cocos/framework/components/event");

var EmailItemBase = xClass("EmailItemBase", Event, function () {
    return new cc.Node();
})

EmailItemBase.prototype.ctor = function () {
    let self = this;
    self.EmailMgr = EmailManager.getInstance();
    self.data = {};
    self.initUI();
}

EmailItemBase.prototype.initUI = function () {
    let self = this;
    self.title = self.getChildByName("title");
    self.btn = self.getChildByName("lib_btn_green_normal");
    self.btnText = self.btn.getChildByName("txt");
    self.time1 = self.getChildByName("label2");
    self.timeL = self.getChildByName("time");
    //
    self.received = self.getChildByName("icon_received");
    self.unreceive = self.getChildByName("icon_unreceive");
    self.status_gift = self.getChildByName("status_gift");
    //
    self.mask = self.getChildByName("mask");
    if (self.mask) {
        self.maskTip = self.mask.getChildByName("tip");
    }
    //
    quickBuildUIButtonNoAction(self, function () {
        if (self.EmailMgr.isBusy || !self.data) return;
        self.EmailMgr.isBusy = true;
        self.onClick();
    });

    if (self.btn) {
        quickBuildUIButton(self.btn, function () {
            if (self.EmailMgr.isBusy || !self.data) return;
            self.EmailMgr.isBusy = true;
            self.onClickAccept();
        });
    }
    //
    self.setSwallowTouches(false);
}

EmailItemBase.prototype.initData = function (data = {}) {
    let self = this;
    self.data = data;
    //
    self.title.setString(data.mailTitle);
    //
    if (self.timeL) {
        let showTime = false;
        if (data.expireTs) {
            const str = self.getTimeStr(data.expireTs);
            self.timeL.setString(str);
            showTime = true;
        }
        self.timeL.setVisible(showTime);
        self.time1.setVisible(showTime);
    }
}

//获取当前信件的详细信息
EmailItemBase.prototype.getMailInfo = function (succ, fail) {
    let self = this;
    if (self.data.mailContent) {
        succ && succ();
    } else {
        self.EmailMgr.mailOpen(self.data.mailId).then((evt) => {
            succ && succ(evt);
        }).catch(() => {
            fail && fail();
        })
    }
}

//点击按钮
EmailItemBase.prototype.onClickAccept = function () {
    let self = this;
    self.EmailMgr.isBusy = false;
}
//点击整个banner
EmailItemBase.prototype.onClick = function () {
    let self = this;
    self.EmailMgr.isBusy = false;
}

EmailItemBase.prototype.onCleanup = function () {
    let self = this;
}

EmailItemBase.prototype.getTimeStr = function (timeStamp) {
    let self = this;
    const MINTIME = 60;
    const HOURTIME = MINTIME * 60;
    const DAYTIME = HOURTIME * 24;
    //
    let now = self._useLocalTime ? new Date().getTime() : Localhost.time();
    let remain = Math.max(0, timeStamp - now);
    let sec = Math.floor(remain / 1000);
    let day = Math.floor(sec / DAYTIME);
    sec = sec - day * DAYTIME;
    let hour = Math.floor(sec / HOURTIME);
    sec = sec - hour * HOURTIME;
    let min = Math.floor(sec / MINTIME);
    sec = sec - min * MINTIME;

    if (day > 0) {
        return day + "天" + hour + "小时";
    } else if (hour > 0) {
        return hour + "小时" + min + "分钟";
    } else {
        return (min || 1) + "分钟";
    }
}

module.exports = EmailItemBase;
